<template>
    <div v-if="!store.load && config['texts'] != undefined && !store.notFound && (data != undefined && data.length > 0)" id="mews-container" class="relative top-2 h-full max-md:pt-24">
        <div id="container-news-big" class="grid grid-cols-3 gap-4 grid-auto-rows mx-special relative max-md:grid-cols-1">
            <DataCardV2 v-for="info in data.slice(0, 3)" :data="info" data-type="big-news" />
        </div>
        <div id="container-news-small" class="grid grid-cols-5 gap-4 grid-auto-rows mx-third mt-special relative max-md:grid-cols-1">
            <DataCardV2 v-for="info in data.slice(3, 8)" :data="info" data-type="small-news" />
        </div>
        <div v-if="data.length > 8" id="old-news" class="mx-third mt-special ">
            <div id="title-old-news" class="mb-special text-content-subtitle-desktop font-bloggerB">
                <span>
                    {{ config['texts'][0] }}
                </span>
            </div>
            <div id="container-old-news-small" class="grid grid-cols-5 gap-4 grid-auto-rows mt-special relative max-md:grid-cols-1">
                <DataCardV2 v-for="info in data.slice(8,)" :data="info" data-type="small-news" />
            </div>
        </div>
    </div>
    <DatanotFound v-if="store.notFound" :message="t('Not-found')" />
    <NoData v-if="data.length < 1 && !store.notFound" :message="t('No-data-news')"/>
</template>

<script setup>
import { ref, onBeforeMount, watchEffect, nextTick } from 'vue';
import { generalStore } from '@/stores';
import { newStore } from '@/stores/news';
import DataCardV2 from '@/components/utils/DataCardV2.vue';
import DatanotFound from '@/components/utils/DatanotFound.vue';
import NoData from '@/components/utils/NoData.vue';
import { useTranslation } from 'i18next-vue';

const store = generalStore();
const storeN = newStore();
const route = store.route;
const { t } = useTranslation();

var config = ref([]);
var data = ref([]);

store.setIsPP(false)
storeN.setDetailNew(null)

onBeforeMount(async () => {
    window.scrollTo(top);
    await store.getConfiguration(route.name);
    await storeN.getAllNews();
    await nextTick();
    data.value = storeN.getNews();
    config.value = store.getSessionStorage('configuration-' + route.name);
})

watchEffect(() => {
    if ((store.filterC) || (store.filterN)) {
        data.value = store.getFiltered();
    } else {
        if (storeN.getNews() != undefined) {
            data.value = storeN.getNews();
        }
    }
})
</script>